import { gql } from 'graphql-request'

export const QueryBlockRelatedArticles = gql`
  fragment FragmentBlockRelatedArticles on BlockRelatedArticlesModelRecord {
          __typename
          id
          title
          preface
          theme
          articles {
            ... on ArticleModelRecord {
              articlePublishedDate
              slug
              image {
                title
                url
                filename
                mimeType
                width
                height
                responsiveImage {
                  sizes
                  src
                  width
                  height
                  alt
                  title
                  base64
                }
              }
              categories {
                id
                name
                slug
              }
              title
              readingTime
              description
              enabledLocales
              enabledMarkets {
                title
                slugPrefix
              }
            }
            ...on CustomerModelRecord {
              __typename
                id
              title
              slug
              descriptionCustomer: description {
                value
              }
              image {
                title
                url
                filename
                mimeType
                width
                height
                responsiveImage {
                  sizes
                  src
                  width
                  height
                  alt
                  title
                  base64
                }
              }
              actionLabel {
                  ... on MicrocopyModelRecord {
                    key
                  }
              }
            }
          }
        }
`

export const BlockRelatedArticles = {
  __typename: 'BlockRelatedArticles',
  fragmentName: 'FragmentBlockRelatedArticles',
  fragmentQuery: QueryBlockRelatedArticles,
  fragments: []
}
